import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import {materialTitle, materiaisQuery} from "../../material/shared/data.service";
import {MaterialService} from "../../material/shared/material.service";
import {AutoCompleteService} from "../../../../shared/components/autocomplete/autocomplete.service";
import {UtilService} from "../../../../shared/services/util.service";

@Component({
    selector: 'app-material-servico-form-list',
    template: require('./material-servico-form-list.component.html'),
    styles: [require('./material-servico-form-list.component.css')]
})
export class MaterialServicoFormListComponent implements OnInit {
    @Input() list: any[] = [];

    moduleName: any = materialTitle;
    materialObject: any = {};
    newObject: any = {};
    materialQuery: any;
    submitted: boolean = false;
    materialId: string = 'materialSelect';

    form2: FormGroup;
    material = new FormControl('', Validators.required);
    quantidade = new FormControl('', Validators.required);

    constructor(
        private _materialService: MaterialService,
        private _autocompleteService: AutoCompleteService,
        private _utilService: UtilService,

        private _fb: FormBuilder
    ) {
        this.form2 = _fb.group({
            material: this.material,
            quantidade: this.quantidade
        });
    }

    ngOnInit() {
        this.materialQuery = this._utilService.cloneObject(materiaisQuery);
        this.newItem();
    }

    clickRemove(item:any[]) {
        //item[0] = objeto de material / item[1] = index na lista
        let onDelete = (function() {
            this.list.splice(item[1], 1);
        }.bind(this));

        this._utilService.swalMessageDelete(onDelete, true);
    }

    onSubmit(evt: any) {
        this.submitted = true;
        if(evt.valid) {
            let object: any = this._utilService.cloneObject(this.newObject);

            if (this.materialObject.id) {
                object.material = this.materialObject;
                this.setNewList(object);
            }
        }
    }

    getMaterialObject(object: any) {
        this.materialObject = object;
        this._utilService.setSelectOnFormControl(this.form2, 'material', object);
    }

    materialTemplateResult = (function(state: any) {
        var template: any = this._materialService.templateResult(state, false);
        return template;
    }.bind(this));

    private newItem() {
        let object: any = {
            quantidade: null,            
            ativo: true
        };
        this.newObject = object;
    }

    private setNewList(object: any) {
        this.list.push(object);

        this.newItem();
        this.materialObject = {};
        this._autocompleteService.setValueOnSelect2(null, this.materialId);
        this._utilService.setSelectOnFormControl(this.form2, 'material', {});

        this.submitted = false;
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/materiais/material-servico/material-servico-form-list/material-servico-form-list.component.ts
 **/